<script>
export default {
  name: 'SkiDatePicker',
  props: {
    title: {
      type: String,
      default: 'Date',
    },
    date: {
      type: String,
      default: new Date().toISOString()
        .substr(0, 10),
    },
    allowedDates: {
      type: Function,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<template>
  <v-container class="pa-0">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      max-width="290px"
      min-width="290px"
      transition="scale-transition"
      offset-y
      lazy
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          :disabled="disabled"
          :label="title"
          :value="computedDateFormatted"
          prepend-icon="event"
          readonly
        />
      </template>
      <v-date-picker
        @change="$emit('onChange', $event);"
        @input="menu = false"
        :value="date"
        :allowed-dates="allowedDates"
        no-title
      />
    </v-menu>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/ski/skipass/SkiDatePicker.vue